import { useRef, useEffect } from 'react';

interface JsonLdProps {
  schema: Record<string, unknown>;
}

export default function JsonLd({ schema }: JsonLdProps) {
  const ref = useRef<HTMLScriptElement | null>(null);

  useEffect(() => {
    if (!ref.current) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
      ref.current = script;
    }
    return () => {
      if (ref.current) {
        document.head.removeChild(ref.current);
        ref.current = null;
      }
    };
  }, [schema]);

  return null;
}